import { useEffect, useState } from "react";
import useLogin from "../../hooks/useLogin";
import ArrowGoBack from "../ArrowGoBack/ArrowGoBack";
import BoardHeaderMobilePublic from "../Headers/BoardHeaderMobilePublic";
import BoardHeaderPublic from "../Headers/BoardHeaderPublic";
import Footer from "../Footer/Footer";
import styles from "./index.module.css";

const BackgroundLayout = ({ children }) => {
  const mediaQuery = window.matchMedia("(max-width: 427px)");

  return (
    <div className={`general-content`}>
      <div className={styles.content}>
        <div className="B-H">
          {!mediaQuery.matches ? (
            <BoardHeaderPublic />
          ) : (
            <BoardHeaderMobilePublic />
          )}
        </div>
        <div className={styles.center}>
          <div>{children}</div>
        </div>
      </div>

      {!mediaQuery.matches ? (
        <div className="con-foo">
          <Footer classN="fooInDash" />
        </div>
      ) : null}
    </div>
  );
};

export default BackgroundLayout;
